import React from "react";
import {cn} from "../utils";

const TvIcon = (
        {
            className,
            color
        }: {
            className?: string,
            color?: string
        } & React.SVGProps<SVGSVGElement>) => (
        <svg fill="none"
             height="512"
             viewBox="0 0 24 24"
             width="512"
             className={cn(className)}
             xmlns="http://www.w3.org/2000/svg">
            <g clipRule="evenodd" fill={color || "currentColor"} fillRule="evenodd">
                <path
                    d="m9.94358 1.25h4.11282c1.8378-.00002 3.2934-.00003 4.4326.15314 1.1724.15762 2.1214.48974 2.8698 1.2381.7483.74837 1.0804 1.69732 1.2381 2.86974.1531 1.13921.1531 2.59485.1531 4.43261v.11281c0 1.8378 0 3.2934-.1531 4.4326-.1577 1.1724-.4898 2.1214-1.2381 2.8698-.7484.7483-1.6974 1.0804-2.8698 1.2381-1.1392.1531-2.5948.1531-4.4326.1531h-4.11281c-1.83776 0-3.2934 0-4.43261-.1531-1.17242-.1577-2.12137-.4898-2.86974-1.2381-.74836-.7484-1.08048-1.6974-1.2381-2.8698-.15317-1.1392-.15316-2.5948-.15314-4.4326v-.11282c-.00002-1.83776-.00003-3.29339.15314-4.4326.15762-1.17242.48974-2.12137 1.2381-2.86974.74837-.74836 1.69732-1.08048 2.86974-1.2381 1.13921-.15317 2.59484-.15316 4.4326-.15314zm-4.23273 1.63976c-1.00609.13526-1.58574.38893-2.00895.81214s-.67688 1.00286-.81214 2.00895c-.13817 1.02766-.13976 2.38233-.13976 4.28915 0 1.9068.00159 3.2615.13976 4.2892.13526 1.006.38893 1.5857.81214 2.0089s1.00286.6769 2.00895.8121c1.02766.1382 2.38233.1398 4.28915.1398h4c1.9068 0 3.2615-.0016 4.2892-.1398 1.006-.1352 1.5857-.3889 2.0089-.8121s.6769-1.0029.8121-2.0089c.1382-1.0277.1398-2.3824.1398-4.2892 0-1.90682-.0016-3.26149-.1398-4.28915-.1352-1.00609-.3889-1.58574-.8121-2.00895s-1.0029-.67688-2.0089-.81214c-1.0277-.13817-2.3824-.13976-4.2892-.13976h-4c-1.90682 0-3.26149.00159-4.28915.13976z"/>
                <path
                    d="m12 21.75c-1.3314 0-2.57518.3324-3.64338.9098-.3644.1969-.81946.0612-1.01641-.3032s-.06122-.8194.30318-1.0164c1.28518-.6946 2.77371-1.0902 4.35661-1.0902s3.0714.3956 4.3566 1.0902c.3644.197.5001.652.3032 1.0164-.197.3644-.652.5001-1.0164.3032-1.0682-.5774-2.312-.9098-3.6434-.9098z"/>
            </g>
        </svg>
    )
;

export {TvIcon};